import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  ApprovalItemLiteModel,
  ApprovalItemModel,
  getApprovalItemInput,
  getApprovalItemsInput,
} from './model';

export function useGetApprovalItems(
  input?: getApprovalItemsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<ApprovalItemLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<ApprovalItemLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getApprovalItems', input?.params],
      () =>
        QueryFetchFunction({
          url: 'approval-items',
          params: input?.params,
        }),
      options,
    ),
    ApprovalItemLiteModel,
  );
}

export function useGetApprovalItem(
  input?: getApprovalItemInput,
  options?: UseQueryOptions<ApiResult<ApprovalItemModel>, ApiError>,
): UseQueryResult<ApiResult<ApprovalItemModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getApprovalItem', input?.id],
      () => QueryFetchFunction({ url: `approval-items/${input?.id}` }),
      options,
    ),
    ApprovalItemModel,
  );
}

export function getApprovalItemsKey(input?: getApprovalItemsInput) {
  return ['getApprovalItems', input?.params];
}

export function getApprovalItemKey(input?: getApprovalItemInput) {
  return ['getApprovalItem', input?.id];
}
